import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getSeasonsAction } from '../../../services/request';
import { SeasonList } from './season/SeasonList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const SeasonRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getSeasonsAction(search, 'GET'));
  const optionsRequest = useQuery(getSeasonsAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [seasons, setSeasons] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [allSeasons, setAllSeasons] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setSeasons(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setAllSeasons(optionsRequest.payload.actions.GET.season.choices);
    }
  }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setSeasons(
        _.map(seasons, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setSeasons(_.filter(seasons, obj => obj.id !== obj2.id));
    } else {
      setSeasons([obj2, ...seasons]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Box display="flex" justifyContent="center">
      </Box>
      <SeasonList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        seasons={seasons}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        allSeasons={allSeasons} />
    </>
  );
};
